const ProfileIcon = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="39" height="40" viewBox="0 0 39 40" fill="none">
        <circle cx="19.2" cy="20" r="19.2" fill="#D9D9D9" />
      </svg>
  );
};
export default ProfileIcon;
